/**
 * Created by petr on 31.12.14.
 */

/**
 * Общие функции приложения
 */
moment.locale('ru');

$(document).ready(function () {
    // Сохранение текста из TinyMCE перед отправкой
    $('button#mailjet_save, button#mailjet_test').on('click', function (event) {
        tinyMCE.triggerSave();
    });

    // Ссылка на списки рассылок из таблицы
    $('table.table-blue tbody tr.interactive.link').on('click', function (event) {
        window.location.href = $(this).data('url');
    });

    $('#users a').on('click', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', '[name="task[clients_select]"]', function (e) {
        var selects = $(this).closest('form').find('[name^="task[clients_users]"],[name^="task[clients_other]"]');

        $(selects).closest('.row').addClass('hidden');
        $(selects).filter('[name="task[clients_' + $(this).val() + ']"]').closest('.row').removeClass('hidden');
    });

    /**
     * Панель формирования списка для отправки писем
     */
    $('body').on('click', '#send-filtered-mail', function (e) {
        e.preventDefault();

        var selectedUrl = $(this).data('selected-url'),
            allUrl = $(this).data('all-url') + window.location.search,
            $checkedClients = $('[name^="merge"]:checked');

        if ($checkedClients.length > 0) {
            $.post(selectedUrl, $.param($checkedClients), function (data) {
                if (data != 0) {
                    window.location.href = data;
                }
            });
        } else {
            $.get(allUrl, function (data) {
                if (data != 0) {
                    window.location.href = data;
                }
            });

        }
    });
});

jQuery.fn.center = function () {
    this.css("position", "absolute");
    this.css("top", Math.max(0, (($(window).height() - $(this).outerHeight()) / 2) +
    $(window).scrollTop()) + "px");
    this.css("left", Math.max(0, (($(window).width() - $(this).outerWidth()) / 2) +
    $(window).scrollLeft()) + "px");
    return this;
};

function setCookie(name, value, expires, path, domain, secure) {
    document.cookie = name + "=" + escape(value) +
    ((expires) ? "; expires=" + expires : "") +
    ((path) ? "; path=" + path : "") +
    ((domain) ? "; domain=" + domain : "") +
    ((secure) ? "; secure" : "");
}

function getCookie(name) {
    var cookie = " " + document.cookie;
    var search = " " + name + "=";
    var setStr = null;
    var offset = 0;
    var end = 0;

    if (cookie.length > 0) {
        offset = cookie.indexOf(search);

        if (offset != -1) {
            offset += search.length;
            end = cookie.indexOf(";", offset)

            if (end == -1) {
                end = cookie.length;
            }

            setStr = unescape(cookie.substring(offset, end));
        }
    }

    return (setStr);
}

function GetStrNumEnd(cnt, e1, e2, e3) {
    var end_str = '';

    end_100 = cnt % 100;
    end_10 = cnt % 10;

    if (end_100 == 11 || end_100 == 12 || end_100 == 13 || end_100 == 14) {
        end_str = e3;
    } else if (end_10 == 1) {
        end_str = e1;
    } else if (end_10 == 2 || end_10 == 3 || end_10 == 4) {
        end_str = e2;
    } else {
        end_str = e3;
    }

    return end_str;
}